import "./Print.css";
import React, { useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Img_logo_print from "../../../assets/custom/classic/logo_print.png";
import Img_icon_printer from "../../../assets/custom/classic/icon_printer.png";
import Img_icon_xls from "../../../assets/custom/classic/icon_xls.png";
import Img_icon_csv from "../../../assets/custom/classic/icon_csv.png";
import { useReactToPrint } from "react-to-print";
import { AudienceContext } from "../../../context/AudienceContext";
import {
  setpopErrorStorage,
} from "../../../context/utils";
import { PrintPagebase64 } from "./PrintPageType";
import { PrintPageHeader, PrintPageTableDet, PrintPageTableMediaComp, exportCSV, exportXLS } from "./PrintPageUtils";
import { DivMinuteEnum, DivChartEnum } from "../../../utils/enums";

export default function PrintPage({
  DivMinute,
  DivChart,
  pp_user,
  comboHoras,
  pp_channels,
  data,
  onClose,
  dataini,
  indiceaverage,
}) {
  const { t } = useTranslation();
  // CRONÔMETRO/TIMER - COMENTADO PARA TESTES
  // const [counter, setCounter] = React.useState(60);
  const componentRef = useRef(null);
  // const timerRef = useRef<NodeJS.Timeout | null>(null);
  const {
    doAudiencePrint,
    audiencePrint,
    audienceMediaCompPrint,
    audienceMediaFirstTable,
    audienceMedia,
    doAudienceMediaPrint, doAudienceMediaCompPrint } = useContext(AudienceContext);
  const [imgs] = React.useState<PrintPagebase64[]>([]);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforePrint: () => closePrint(),
  });

  async function doPrint() {
    if (DivChart === DivChartEnum.MedComp) {
      await doAudienceMediaCompPrint(dataini, indiceaverage);
    }
    if (DivMinute === DivMinuteEnum.Media) {
      await doAudienceMediaPrint();
      return;
    }
    if (DivMinute === DivMinuteEnum.Minute) {
      doAudiencePrint(
        data,
        comboHoras.HrIni + ":" + comboHoras.MinIni,
        comboHoras.HrFim + ":" + comboHoras.MinFim
      );
    }
  }

  useEffect(() => {
    doPrint();
  }, []);

  function closePrint() {
    onClose(true);
  }
  if (audiencePrint !== undefined && audiencePrint.length > 0) {
    if (audiencePrint[0] === "ERRO") {
      setpopErrorStorage(audiencePrint[2]);
      closePrint();
      return <></>;
    } else {
      setpopErrorStorage("");
    }

    if (audiencePrint[0][1].match("-")) {
      let priEl = audiencePrint.shift();
      audiencePrint.push(priEl);
    }
    return (
      <div className="pop-content">
        {/* CRONÔMETRO/TIMER - EXIBIÇÃO COMENTADA PARA TESTES */}
        {/* <div>Esta tela fechará em: {counter}</div> */}
        <div className="printpage-div-btn">
          <img
            alt="export CSV"
            data-testid="btnexportCSV"
            className="printpage-btns"
            id="exportCSV"
            src={Img_icon_csv}
            onClick={() =>
              exportCSV(
                audiencePrint,
                audienceMediaCompPrint,
                pp_channels,
                t,
                pp_user,
                closePrint,
                imgs,
                DivChart,
                DivMinute
              )
            }
          />

          <img
            alt="export XLS"
            data-testid="exportXLS"
            className="printpage-btns"
            id="exportXLS"
            src={Img_icon_xls}
            onClick={() => exportXLS(pp_user, componentRef, closePrint, audienceMediaCompPrint, DivChart, DivMinute)}
          />

          <img
            alt="print"
            className="printpage-btns"
            id="print"
            src={Img_icon_printer}
            onClick={handlePrint}
          />
        </div>
        <div id="divPrintPage" ref={componentRef}>
          <div data-testid="divPrintPage" className="printpage-popup">
            <div className="printpage-logo ">
              <img alt="print" id="print" src={Img_logo_print} />
            </div>
            <div id="divPrintPage-Body">
              <div className="printpage-header">
                <PrintPageHeader
                  ppUser={pp_user}
                  translateService={t}
                ></PrintPageHeader>
              </div>
              <div className="printpage-body">
                {DivChart === DivChartEnum.MedComp && audienceMediaCompPrint.length > 0 && (
                  <>
                    <div className="printpage-mid-header">
                      Médias Comparativas
                    </div>
                    <PrintPageTableMediaComp
                      audienceMediaCompPrint={audienceMediaCompPrint}
                    />
                  </>
                )}
                <label id="LAB_HEADER" className="printpage-mid-header">
                  {" "}
                  {DivMinute === DivMinuteEnum.Media 
                    ? t("secret.rows.printTableTitle.merged") 
                    : t("secret.rows.printTableTitle.list")}
                </label>
                <PrintPageTableDet
                  audiencePrint={audiencePrint}
                  pp_channels={pp_channels}
                  pp_user={pp_user}
                ></PrintPageTableDet>
              </div>
            </div>
          </div>
        </div>
        <iframe
          title="ifmcontentstoprint"
          id="ifmcontentstoprint"
          style={{ height: "0px", width: "0px", position: "absolute" }}
        ></iframe>
      </div>
    );
  } else {
    return (
      <div data-testid="divPrintPage" className="printpage-popup">
        {/* CRONÔMETRO/TIMER - EXIBIÇÃO COMENTADA PARA TESTES */}
        {/* <div>Esta tela fechará em: {counter}</div> */}
        <div className="printpage-logo ">
          <img alt="print" id="print" src={Img_logo_print} />
        </div>
        <label> {t("network.loadingData")} </label>
      </div>
    );
  }
}
